<script>
import {mapState, mapActions} from 'vuex';
import DropdownMenu from '../DropdownMenu/DropdownMenu.vue';

export default {
    components: {
        DropdownMenu
    },
    computed: {
        ...mapState({
            sites: state => state.stats.sites,
            selectedItem: state => state.stats.statList.selectedItem,
            predicate: state => state.stats.statList.predicate,
            predicates: state => state.stats.statList.predicates
        }),
        filteredSites () {
            let _sites = [...this.sites];
            _sites.sort((a, b) => {
                return b[this.predicate] - a[this.predicate];
            });
            return _sites.slice(0, 10);
        },
        filteredItems () {
            if (!this.selectedItem || !this.selectedItem.accommodations) {
                return undefined;
            }
            let _items = [...this.selectedItem.accommodations];
            _items.sort((a, b) => {
                return b[this.predicate] - a[this.predicate];
            });
            return _items.slice(0, 10);
        },
    },
    methods: {
        ...mapActions({
            updateSelectedStatListItem: 'stats/updateSelectedStatListItem',
            setFilter: 'stats/setFilter'
        }),
    }
}
</script>
<template>
    <div class="stat-list">
        <div v-if="sites" class="stat-list__content">
            <div class="stat-list__header">
                {{ $t('statList.heading') }}
            </div>
            <div class="stat-list__body">
                <div class="stat-list__option">
                    <dropdown-menu :label="$t('statSites.dropdown.label')"
                                   :value="predicate"
                                   :items="predicates"
                                   :translation-prefix="'statSites.predicate'"
                                   @input="setFilter({list: $event})"/>
                </div>
                <div class="stat-list__items">
                    <div v-for="site in filteredSites"
                         :key="site.id"
                         class="stat-list__item"
                         @click="updateSelectedStatListItem(site)">
                        <div class="stat-list__label">
                            {{ site.name }}
                        </div>
                        <div class="stat-list__value">
                            {{ predicate === 'revenue' ? '€' : '' }}
                            {{ $shortNumber(site[predicate]) }}
                        </div>
                    </div>
                    <transition name="slide-in">
                        <div v-if="selectedItem" class="stat-list__inventory">
                            <div class="stat-list__inventory-back"
                                 @click="updateSelectedStatListItem(undefined)">
                                {{ $t('statList.backButton') }}
                            </div>
                            <div class="stat-list__inventory-list">
                                <div v-for="item in filteredItems"
                                     :key="item.id"
                                     class="stat-list__inventory-item">
                                    <div class="stat-list__inventory-label">
                                        {{ item.name }}
                                    </div>
                                    <div class="stat-list__inventory-value">
                                        {{ predicate === 'revenue' ? '€' : '' }}
                                        {{ $shortNumber(item[predicate]) }}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </transition>
                </div>
            </div>
        </div>
    </div>
</template>



// WEBPACK FOOTER //
// src/components/StatList/StatList.vue